import { throwCaptured } from '../../../utils'

import { ConnectwareError, ConnectwareErrorType } from '../../../domain'

import type { HttpResponse } from '..'

/**
 * This is a temporary function that extract unknown json responses
 * Yielding either a validated value or an error
 *
 * This ensures values are coming in as expected from the backend
 *
 * @todo no longer use this and rely on backend response documentation instead
 * @deprecated
 * @see https://cybusio.atlassian.net/browse/CC-2690
 */
export const extractValidatedJson = async <T>(response: HttpResponse<number, unknown>, isValid: (value: unknown) => value is T): Promise<T> => {
    const json = await response.getJson()

    if (isValid(json)) {
        return json
    }

    const error = new ConnectwareError(ConnectwareErrorType.UNEXPECTED, 'Response had unexpected json', { json, validator: isValid.name })
    return throwCaptured(error, extractValidatedJson)
}
